<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <RightSide></RightSide>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue